export function TodoItem({ completed, id, title, toggleTodo, deleteTodo}){

    return (
        <li>    <div className="items"><div className="item">
                <label>
                <input type="checkbox" 
                checked={completed}
                onChange={e => toggleTodo(id, e.target.checked)}
                />
                {title}
                </label>
                </div><div className="del-btn">
                <button className="btn btn-delete"
                onClick={() => deleteTodo(id)}
                >Delete</button>
                </div>
                </div>
                </li>
                



    )
}